import { useDispatch, useSelector } from 'react-redux';

import type { RootState } from '../store';

export default function useAuthUser() {
  const dispatch = useDispatch();
  const { user: authUser } = useSelector((state: RootState) => state.auth);

  return { dispatch, authUser };
}
